import calendarCheck from '../assets/img/icon-event-available.svg';
import calendarX from '../assets/img/icon-event-busy.svg';
import dollarSign from '../assets/img/icon-dollar-sign.svg';
import peopleGroup from '../assets/img/icon-people.svg';
import star from '../assets/img/ki-star-f.svg';
export const resolveIcon = (iconName: string) => {
    switch (iconName) {
        case `calendar_check`:
            return calendarCheck;

        case `calendar_x`:
            return calendarX;

        case `dollar_sign`:
            return dollarSign;

        case `people_group`:
            return peopleGroup;

        case `star`:
            return star;
    }

    return null;
};
